import { Text, Code } from '@customerio/pluma-components/react';
import type { UnknownNode } from '../../types';
import { ConditionCard } from '../condition-card';

interface UnknownConditionProps {
  node: UnknownNode;
}

export function UnknownCondition({ node }: UnknownConditionProps) {
  // Show a compact summary of the raw JSON keys
  const keys = Object.keys(node.raw);
  const summary = keys.length > 0 ? keys.join(', ') : 'empty';

  return (
    <ConditionCard node={node}>
      <Text as="span" color="subtle">
        Unknown condition:{' '}
      </Text>
      <Code>{summary}</Code>
    </ConditionCard>
  );
}
